module.exports = __webpack_public_path__ + "static/media/YB5F17_4.66c6e305.jpg";